webpackJsonp([192],{

/***/ 1168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderAppealTable_vue__ = __webpack_require__(2841);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_675c02de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderAppealTable_vue__ = __webpack_require__(4816);
function injectStyle (ssrContext) {
  __webpack_require__(4814)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-675c02de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderAppealTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_675c02de_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderAppealTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getExel */
/* unused harmony export getExelByPost */
/* harmony export (immutable) */ __webpack_exports__["a"] = NumberArray;
/* unused harmony export StringArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var base = window._env_.VUE_APP_HOST;
function getExel(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var data = {
      method: 'GET',
      url: base + url,
      headers: {
        Authorization: localStorage.getItem('tokenType') + ' ' + localStorage.getItem('token'),
        'Authorization-Guard': localStorage.getItem('guard')
      },
      responseType: 'arraybuffer',
      params: params
    };
    resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(data));
  });
}
function getExelByPost(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var data = {
      method: 'post',
      url: base + url,
      data: params,
      headers: {
        Authorization: localStorage.getItem('tokenType') + ' ' + localStorage.getItem('token'),
        'Authorization-Guard': localStorage.getItem('guard')
      },
      responseType: 'arraybuffer'
    };
    resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(data));
  });
}

// 将字符串数组转换为数字数组
function NumberArray(value) {
  var valueArray = Array.isArray(value) ? value : [value];
  return valueArray.map(function (item) {
    return Number(item);
  });
}

function StringArray(value) {
  // 如果 value 不是数组，则将其转换成数组
  var valueArray = Array.isArray(value) ? value : [value];
  return valueArray.map(function (item) {
    return String(item);
  });
}

/***/ }),

/***/ 2016:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return orderAppealMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var orderAppealMixin = {
  data: function data() {
    return {
      appealStatusOptions: [{ label: '申诉中', value: 1 }, { label: '申诉成功', value: 2 }, { label: '申诉失败', value: 3 }, { label: '已撤回', value: 4 }, { label: '超时关闭', value: 5 }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({})),
  methods: {}
};

/***/ }),

/***/ 2029:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrderAppealListTabs',
  props: {
    active: {
      type: String,
      required: true
    }
  },
  methods: {
    onTabClick: function onTabClick(tab) {
      var name = tab.name;
      if (name === this.active) return;
      if (name === 'internStat') {
        this.$router.push({ path: '/order/appeal/intern-stat' });
        return;
      }
      this.$router.push({ path: '/order/appeal/table' });
    }
  }
});

/***/ }),

/***/ 2375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderAppealListTabs_vue__ = __webpack_require__(2029);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a487c6f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderAppealListTabs_vue__ = __webpack_require__(2378);
function injectStyle (ssrContext) {
  __webpack_require__(2376)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a487c6f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderAppealListTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a487c6f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderAppealListTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2376:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2377);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("214aca8e", content, true, {});

/***/ }),

/***/ 2377:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".order-appeal-list-tabs[data-v-5a487c6f] .el-tabs__header{margin:0 0 12px}.order-appeal-list-tabs[data-v-5a487c6f] .el-tabs__content{display:none}", "", {"version":3,"sources":["/workspace/src/views/order/components/OrderAppealListTabs.vue"],"names":[],"mappings":"AACA,0DAA0D,eAAe,CACxE,AACD,2DAA2D,YAAY,CACtE","file":"OrderAppealListTabs.vue","sourcesContent":["\n.order-appeal-list-tabs[data-v-5a487c6f] .el-tabs__header{margin:0 0 12px\n}\n.order-appeal-list-tabs[data-v-5a487c6f] .el-tabs__content{display:none\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{staticClass:"order-appeal-list-tabs",attrs:{"value":_vm.active},on:{"tab-click":_vm.onTabClick}},[_c('el-tab-pane',{attrs:{"label":"申诉列表","name":"appeal"}}),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"实习生统计","name":"internStat"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2841:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_common__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_order_mixins_order_appeal_mixins_js__ = __webpack_require__(2016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_order_components_OrderAppealListTabs_vue__ = __webpack_require__(2375);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { OrderAppealListTabs: __WEBPACK_IMPORTED_MODULE_4__views_order_components_OrderAppealListTabs_vue__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_table_v3__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__views_order_mixins_order_appeal_mixins_js__["a" /* orderAppealMixin */]],
  data: function data() {
    var _this = this;

    return {
      table: [],
      dialogBatchVisible: false,
      exportAsync: false,
      appealTimeRange: [],
      search: {
        status: [1],
        orderid: null,
        customerid: null,
        projectid: null,
        batchid: null,
        order_reviewer_id: null,
        userid: null,
        created_at: []
      },
      searchFieldType: {
        customerid: Number,
        projectid: Number,
        batchid: Number,
        order_reviewer_id: Number,
        userid: Number,
        status: __WEBPACK_IMPORTED_MODULE_2__utils_common__["a" /* NumberArray */]
      },
      exportHeader: [{ key: 'id', text: 'ID' }, { key: 'orderid', text: '工单ID', formatter: function formatter(row) {
          return 'ORD' + (row.orderid || '');
        } }, { key: 'task_title', text: '任务名称' }, { key: 'project_name', text: '项目名称/编号', formatter: function formatter(row) {
          return (row.project_name || '') + '/' + (row.project_number || '');
        } }, { key: 'batch_name', text: '批次名称', formatter: function formatter(row) {
          return row.batch_name || '';
        } }, { key: 'provincename', text: '省份', formatter: function formatter(row) {
          return row.provincename || '';
        } }, { key: 'cityname', text: '城市', formatter: function formatter(row) {
          return row.cityname || '';
        } }, { key: 'areaname', text: '地区', formatter: function formatter(row) {
          return row.areaname || '';
        } }, { key: 'order_reviewer_name', text: '最后审核人', formatter: function formatter(row) {
          return row.order_reviewer_name + '/' + row.order_reviewer_id;
        } }, { key: 'status', text: '当前状态', formatter: function formatter(row) {
          return _this.getAppealStatusLabel(row.status);
        } }, { key: 'appeal_reason', text: '申诉原因', formatter: function formatter(row) {
          return row.appeal_reason || '';
        } }, { key: 'userid', text: '零工ID', formatter: function formatter(row) {
          return row.userid || '';
        } }, { key: 'created_at', text: '发起时间', formatter: function formatter(row) {
          return row.created_at || '';
        } }, { key: 'audit_adminname', text: '申诉处理人', formatter: function formatter(row) {
          return row.audit_adminname || '';
        } }, { key: 'audited_at', text: '申诉处理时间', formatter: function formatter(row) {
          return row.audited_at || '';
        } }]
    };
  },
  created: function created() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.order.options;
    },
    users: function users(state) {
      return state.login.user;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['getCustomerTable', 'getCustomerDetail', 'getProjectTable', 'getProjectDetail', 'getBatchTable', 'getBatchDetail']), Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']), {
    getAppealStatusTag: function getAppealStatusTag(value) {
      var map = { 1: 'warning', 2: 'success', 3: 'danger', 4: 'info', 5: 'info' };
      return map[value] || 'info';
    },
    getTableData: function getTableData(params) {
      var _this2 = this;

      return request.common('queryOrderAppealTableApi', params).then(function (res) {
        if (res && res.detail && Array.isArray(res.detail.data)) {
          res.detail.data = res.detail.data.map(function (item) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
              project_info: item.project_name + '/' + item.project_number,
              status_label: _this2.getAppealStatusLabel(item.status)
            });
          });
        }
        return res;
      });
    },
    getAppealStatusLabel: function getAppealStatusLabel(value) {
      var item = this.appealStatusOptions.find(function (i) {
        return i.value === value;
      });
      return item ? item.label : '未知';
    },
    onExportSearch: function onExportSearch() {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: Object(__WEBPACK_IMPORTED_MODULE_1__core_mixins_table_v3__["b" /* removeEmptyParams */])(_.cloneDeep(this.search)),
        getResponseData: function getResponseData(data) {
          return data;
        }
      });
    },

    // 跳转到工单申诉审核页（仅申诉中为可处理状态），新标签页打开
    goReview: function goReview(row) {
      if (row.status !== 1) return;

      var _$router$resolve = this.$router.resolve('/order/appeal/review-order/' + row.orderid),
          href = _$router$resolve.href;

      window.open(href, '_blank');
    },
    canAuditOrderAppealBtn: function canAuditOrderAppealBtn() {
      // 具有审核的UI权限
      return filter.hasPermission(40012);
    }
  })
});

/***/ }),

/***/ 4814:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4815);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("243cdc1e", content, true, {});

/***/ }),

/***/ 4815:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OrderAppealTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4816:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("工单管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"申诉状态","prop":"status"}},[_c('el-select',{staticClass:"width-max",attrs:{"multiple":"","placeholder":"请选择申诉状态","clearable":""},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},_vm._l((_vm.appealStatusOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工单ID","prop":"orderid"}},[_c('el-input',{attrs:{"placeholder":"请输入工单ID","clearable":""},model:{value:(_vm.search.orderid),callback:function ($$v) {_vm.$set(_vm.search, "orderid", $$v)},expression:"search.orderid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户","prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请输入客户名称/编号搜索","query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail},model:{value:(_vm.search.customerid),callback:function ($$v) {_vm.$set(_vm.search, "customerid", $$v)},expression:"search.customerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目","prop":"projectid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目 名称 进行搜索","query-request":_vm.getProjectTable,"find-request":_vm.getProjectDetail},model:{value:(_vm.search.projectid),callback:function ($$v) {_vm.$set(_vm.search, "projectid", $$v)},expression:"search.projectid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"批次","prop":"batchid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"detail","value-key":"id","placeholder":"请输入批次 名称 进行搜索","query-request":_vm.getBatchTable,"find-request":_vm.getBatchDetail},model:{value:(_vm.search.batchid),callback:function ($$v) {_vm.$set(_vm.search, "batchid", $$v)},expression:"search.batchid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"审核人","prop":"order_reviewer_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入管理员名称搜索","query-request":_vm.getPlatformUsersIndex,"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.order_reviewer_id),callback:function ($$v) {_vm.$set(_vm.search, "order_reviewer_id", $$v)},expression:"search.order_reviewer_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"申诉零工ID","prop":"userid"}},[_c('el-input',{attrs:{"placeholder":"请输入申诉零工ID","clearable":""},model:{value:(_vm.search.userid),callback:function ($$v) {_vm.$set(_vm.search, "userid", $$v)},expression:"search.userid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"申诉发起时间","prop":"created_at"}},[_c('el-date-picker',{staticClass:"width-max",attrs:{"value-format":"yyyy-MM-dd HH:mm:ss","type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"center","clearable":""},model:{value:(_vm.search.created_at),callback:function ($$v) {_vm.$set(_vm.search, "created_at", $$v)},expression:"search.created_at"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit","size":"mini"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('order-appeal-list-tabs',{attrs:{"active":"appeal"}}),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.onExportSearch}},[_vm._v("按搜索结果导出\n      ")])],1),_vm._v(" "),_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"id","width":"100","label":"ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"orderid","width":"116px","label":"工单ID"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'/order/detail/'+scope.row.orderid}},[_c('span',{staticStyle:{"color":"rgb(88,157,248)"}},[_vm._v("ORD"+_vm._s(scope.row.orderid))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"task_title","width":"150px","label":"任务名称"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"项目名称/编号","min-width":"150px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.project_name)+" / "+_vm._s(scope.row.project_number)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"batch_name","label":"批次名称","min-width":"120px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"provincename","label":"省份","width":"90px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cityname","label":"城市","width":"90px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"areaname","label":"地区","width":"90px"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"order_reviewer_id","label":"最后审核人","width":"94px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.order_reviewer_name || '-')+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"当前状态","width":"92px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":_vm.getAppealStatusTag(scope.row.status),"size":"mini"}},[_vm._v(_vm._s(_vm.getAppealStatusLabel(scope.row.status))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"appeal_reason","label":"申诉原因","min-width":"160px","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userid","label":"零工ID","width":"84px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.userid)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"发起时间","width":"160px","prop":"created_at"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"audit_adminid","label":"申诉处理人","width":"94px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.audit_adminname || '-')+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"申诉处理时间","width":"160px","prop":"audited_at"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"150px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('button-gutter',[(_vm.canAuditOrderAppealBtn())?_c('el-button',{attrs:{"type":"primary","size":"mini","disabled":scope.row.status !== 1},on:{"click":function($event){return _vm.goReview(scope.row)}}},[_vm._v("处理\n            ")]):_vm._e(),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":("/order/appeal/detail/" + (scope.row.id)),"target":"_blank"}},[_c('el-button',{attrs:{"type":"success","size":"mini"}},[_vm._v("申诉详情\n              ")])],1)],1)]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/order-appeal-table.17900bcf3a5e6bc6749b.js